export function trimpTss (activity,user){
    if (activity.type === "Rest"){
        return [0,0]
    }
    
    var rest_hr = user.rest_hr
    var max_hr = user.max_hr
    var heartRate = activity.hrPerc/100*max_hr
    if (activity.subType.includes("Interval")){
        heartRate = calculateHeartRate(activity,max_hr)
    }
    var lactate_th = user.lactate_th
    if (activity.type === "Swim"){
      lactate_th = user.lactate_swim
    }
    if (activity.type === "Ride"){
      lactate_th = user.lactate_cycle
    }
    
    var hrr = (heartRate-rest_hr)/(max_hr-rest_hr)
    var trimp=0
    Math.round(activity.dur)
    for (var i=0;i<activity.dur;i++){
        trimp = trimp + 1 * hrr * 0.64 * Math.exp(1.92 * hrr)
    }
    
    var hr_lthr = (lactate_th - rest_hr)/(max_hr - rest_hr)
    var hour_lthr = 60 * hr_lthr * 0.64 * Math.exp(1.92 * hr_lthr)
    var tss =  (trimp/hour_lthr)*100
    
    return [tss.toFixed(2),trimp]
  }

function calculateHeartRate(activity,max_hr){
    if (activity.subType.includes('1-2')){
        var heartRate = (activity.hrPerc + 2*activity.hrPerLow)/3
        return heartRate/100*max_hr
    }
    if (activity.subType.includes('1-1')){
        heartRate = (activity.hrPerc + 1*activity.hrPerLow)/2
        return heartRate/100*max_hr
    }
    if (activity.subType.includes('1-3')){
        heartRate = (activity.hrPerc + 3*activity.hrPerLow)/4
        return heartRate/100*max_hr
    }
    if (activity.subType.includes('2-1')){
        heartRate = (2*activity.hrPerc + activity.hrPerLow)/3
        return heartRate/100*max_hr
    }
    if (activity.subType.includes('3-1')){
        heartRate = (3*activity.hrPerc + activity.hrPerLow)/4
        return heartRate/100*max_hr
    }
}



export function createDataZones(activity,list,user){
    //console.log(activity,activity.hrPerLow,activity.hrPerc,activity.subType)
    if (activity.subType.includes("Interval")){
        if (reserve(activity.hrPerLow,user)>=90){
            list[5] = list[5] +1
        }
        if (reserve(activity.hrPerLow,user)>=80 && reserve(activity.hrPerLow,user)<90){
            list[4] = list[4] +1
        }
        if (reserve(activity.hrPerLow,user)>=70 && reserve(activity.hrPerLow,user)<80){
            list[3] = list[3] +1
        }
        if (reserve(activity.hrPerLow,user)>=60 && reserve(activity.hrPerLow,user)<70){
            list[2] = list[2] +1
        }
        if (reserve(activity.hrPerLow,user)>=50 && reserve(activity.hrPerLow,user)<60){
            list[0] = list[0] +0.5
            list[1] = list[1] +0.5
        }
        if (reserve(activity.hrPerc,user)>=90){
            list[5] = list[5] +1
        }
        if (reserve(activity.hrPerc,user)>=80 && reserve(activity.hrPerLow,user)<90){
            list[4] = list[4] +1
        }
        if (reserve(activity.hrPerc,user)>=70 && reserve(activity.hrPerLow,user)<80){
            list[3] = list[3] +1
        }
        if (reserve(activity.hrPerc,user)>=60 && reserve(activity.hrPerLow,user)<70){
            list[2] = list[2] +1
        }
        if (reserve(activity.hrPerc,user)>=50 && reserve(activity.hrPerLow,user)<60){
            list[0] = list[0] +0.5
            list[1] = list[1] +0.5
        }
    }
    else{
        if (activity.subType ==="Base/Long Run"){
            list[0] = list[0] +0.5
            list[1] = list[1] +0.5
        }
        if (activity.subType ==="Aerobic 1"){
            list[2] = list[2] +1
        }
        if (activity.subType ==="Aerobic 2"){
            list[3] = list[3] +1
        }
        if (activity.subType ==="Threshold"){
            list[4] = list[4] +1
        }
    }
    return list
}

const reserve = (heartRate,user) =>{
    var res = ((user.max_hr*heartRate/100) - user.rest_hr)/(user.max_hr-user.rest_hr)
    res = parseInt(res*100)
    return res
  }

  

export function goalAerobicSpeedProgress(list){
    var progress = 0

    var low = list[0]+list[1]
    var mid = list[2]+list[3]
    var high = list[4]+list[5]

    var sum = low+mid+high
    low = low*100/sum
    mid = mid*100/sum
    high = high*100/sum
    progress = (high*1+mid*5+low*5)/11
    return progress*1.5
    
    
}
export function goalDistanceProgress(list){
    var progress = 0

    var low = list[0]+list[1]
    var mid = list[2]+list[3]
    var high = list[4]+list[5]

    var sum = low+mid+high
    low = low*100/sum
    mid = mid*100/sum
    high = high*100/sum
    progress = (high*1+mid*3+low*8)/12
    return progress*1.5
    
}
export function goalMaxSpeedProgress(list){
    var progress = 0

    var low = list[0]+list[1]
    var mid = list[2]+list[3]
    var high = list[4]+list[5]
    
    var sum = low+mid+high
    low = low*100/sum
    mid = mid*100/sum
    high = high*100/sum
    progress = (high*8+mid*3+low)/12
   
    return progress*1.5
}